<div class="form-group">
  @if (showSkip) {
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input
          type="checkbox"
          [checked]="skipped"
          [(ngModel)]="skipped"
          (ngModelChange)="onSkipChange()"
          name="add-note-toggle"
          id="skip-driver-details-toggle">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    }
    @for (child of childrenQuestions; track child; let i = $index) {
      @if (i > 0) {
        <div class="hr-or">or</div>
      }
      @if (child?.cent_aq_question_type_id === QuestionType.upload) {
        <div
          class="form-group">
          <app-question-upload
            [question]="child"
            (questionAnswer)="activateNextButton($event)">
          </app-question-upload>
        </div>
      }
      @if (child?.cent_aq_question_type_id === QuestionType.upload_selfie) {
        <div
          class="form-group">
          <app-question-uploaders-selfie
            [question]="child"
            (questionAnswer)="activateNextButton($event)">
          </app-question-uploaders-selfie>
        </div>
      }
      @if (child?.cent_aq_question_type_id === QuestionType.upload_images) {
        <div
          class="form-group">
          <app-question-uploaders-images
            [question]="child"
            (questionAnswer)="activateNextButton($event)">
          </app-question-uploaders-images>
        </div>
      }
      @if (child?.cent_aq_question_type_id === QuestionType.textarea) {
        <div class="form-group form-group--lg"
          >
          <app-question-textarea
            [question]="child"
            (questionAnswer)="activateNextButton($event)">
          </app-question-textarea>
        </div>
      }
      @if (child?.cent_aq_question_type_id === QuestionType.odometer_reading) {
        <div class="form-group form-group--lg"
          >
          <app-question-odometer-reading
            [question]="child"
            (questionAnswer)="activateNextButton($event)">
          </app-question-odometer-reading>
        </div>
      }
    }

    @if (question.question_hint && question.question_bubble) {
      <p
        class="mt-30 mb-15 text-center">
        <a href="#question-modal" class="button-control button-control--opacity-hover" data-toggle="modal">
          <svg class="icon">
            <use xlink:href="#info-icon"></use>
          </svg>
          <span>{{question.question_hint}}</span></a>
        </p>
      }
    </div>
